import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        let token = localStorage.getItem('token');
        if (token && token) {
            request = request.clone({
                
                setHeaders: { 
                    'session-token': token,
                    'user-id': localStorage.getItem('user_id'),
                }
            });
        }

        return next.handle(request);
    }
}